import { useEffect, useState } from 'react';
import { CLIENT_VERSION } from './auth/session';

/** Polls `version.json` (written by buildVersionPlugin) and reports when a newer build is deployed. */
export function useUpdateAvailable(intervalMs = 2 * 60 * 1000): boolean {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    if (CLIENT_VERSION === 'dev' || CLIENT_VERSION === 'test') return;
    let alive = true;
    const check = async () => {
      try {
        const res = await fetch(`${import.meta.env.BASE_URL}version.json?t=${Date.now()}`, {
          cache: 'no-store',
        });
        if (!res.ok) return;
        const { version } = (await res.json()) as { version?: string };
        if (alive && version && version !== CLIENT_VERSION) setAvailable(true);
      } catch {
        /* offline: ignore */
      }
    };
    void check();
    const id = setInterval(check, intervalMs);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [intervalMs]);
  return available;
}
